import React, { useContext, useEffect } from 'react'
import moment from 'moment';
import 'moment/locale/pt-br'; // Importa a localização em português para o moment
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer } from 'react-toastify';
import { RequestsContext } from '../../context/requests'
import { MarketingContext } from '../../context/marketing';
import deleteIcon from '../../images/png/deleteIcon.png'


const CheckBox = styled.input`
    border: 1px solid black;
    width: 24px;
    height: 24px;
`
const ButtonStatus = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    width: 106px;
    height: 28px;
    border: none;
    font-size: 11px;
    border-radius: 60px;

    @media screen and (max-width:820px){
        width: 100%;
        font-size: 9px;
        border-radius:50px;
        
    }


`
const Image = styled.img`
    width:120px;
    height:120px;
    object-fit: contain;
`

const ImageTrash = styled.img`
    width: 25px;
    height:25px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const TableListBanners = ({ data, structure }) => {
    const { get,banners,destroy,getById } = useContext(MarketingContext)

    useEffect(() => {
        get()
    }, [])

    return (
        <div className='container_startpn_table'>
            <table>

                <thead>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>
                    <tbody>
                        {String(banners).length == 0

                            ?
                            <tr>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                            </tr>
                            :

                            banners?.map((item, index) => {

                                return (
                                    <tr key={index}>
                                        <td onClick={() => getById(item.id)}>#{item.id}</td>
                                        <td onClick={() => getById(item.id)}><Image src={item.image}/></td>
                                        <td><a href={item.url} target='_blank'><ButtonStatus  style={{ background: "#FFF7AA", color: "#C6B200" }}>Link banner</ButtonStatus></a></td>
                                        <td onClick={() => destroy(item.id)}><ImageTrash src={deleteIcon}/></td>
                                    </tr>
                                )
                            })}



                    </tbody>


            </table>
        </div>
    )
}

export default TableListBanners